window.LGFG = window.LGFG || {}
window.LGFG.FarmQuote = window.LGFG.FarmQuote || (function () {
    var fenceLength = 0;
    var corners = 0;
    var gates = 0;
    var markerMode = 'gate';

    var drawingManager;


    var fences = [];
    var gateIcons = [];

    var initMap = function () {
        var autocompleteOptions = {
            componentRestrictions: { country: ['au', 'nz'] }
        };
        var autocomplete = new google.maps.places.Autocomplete(document.getElementsByClassName('js-address')[0], autocompleteOptions);

        const map = new google.maps.Map(document.getElementById("fence-design-map"), {
            center: { lat: -34.397, lng: 150.644 },
            zoom: 8,
            mapTypeId: 'satellite'
        });
        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                ]
            },
            markerOptions: {
                icon:
                    "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"
            },
            circleOptions: {
                fillColor: "#ffff00",
                fillOpacity: 1,
                strokeWeight: 5,
                clickable: false,
                editable: true,
                zIndex: 1
            }
        });
        drawingManager.setMap(map);

        google.maps.event.addListener(drawingManager, 'markercomplete', function (marker) {
            gateIcons.push(marker);
            gates = gates + 1;
            corners = corners + 2;
            updateFence(fenceLength, corners, gates);
        });

        google.maps.event.addListener(drawingManager, 'polylinecomplete', function (polyline) {
            fences.push(polyline);
            updateFenceParameters();

            google.maps.event.addListener(polyline, 'dragend', updateFenceParameters);
            google.maps.event.addListener(polyline.getPath(), 'insert_at', updateFenceParameters);
            google.maps.event.addListener(polyline.getPath(), 'remove_at', updateFenceParameters);
            google.maps.event.addListener(polyline.getPath(), 'set_at', updateFenceParameters);
        });

        var updateFenceParameters = function () {
            fenceLength = 0;
            corners = 0;
            for (var i = 0; i < fences.length; i++) {
                var polyline = fences[i];
                var meters = google.maps.geometry.spherical.computeLength(polyline.getPath());
                var pathLength = polyline.getPath().getLength();
                if (isDuplicate(polyline.getPath().getAt(0), polyline.getPath().getAt(pathLength - 1))) {
                    corners = corners + pathLength - 1 + (gates *2);
                }
                else {
                    corners = corners + pathLength + (gates * 2);
                }
                fenceLength = fenceLength + meters;
            }
            updateFence(fenceLength, corners, gates);
        };
        var gotoAddress = function () {
            var geocoder = new google.maps.Geocoder();
            var address = $('.js-address').val();
            geocoder.geocode({ 'address': address }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    map.setCenter(results[0].geometry.location);
                    var marker = new google.maps.Marker({
                        map: map,
                        position: results[0].geometry.location
                    });
                }
            });
        };

        $('.js-goto-address').bind('click', function (event) {
            event.preventDefault();
            gotoAddress();
        });

        addCustomControls(map);
    };
    var isDuplicate = function (firstPoint, lastPoint) {
        if (firstPoint.lat() === lastPoint.lat() && firstPoint.lng() === lastPoint.lng()) {
            return true;
        }
        return false;
    };
    var addCustomControls = function (map) {
        var customControlDiv = document.createElement('div');
        var fenceControlDiv = document.createElement('div');
        var clearControlDiv = document.createElement('div');

        var clearControl = new ClearControl(clearControlDiv, map);
        var customControl = new CustomControl(customControlDiv, map);
        var fenceControl = new FenceControl(fenceControlDiv, map);

        customControlDiv.index = 1;
        fenceControlDiv.index = 2;
        clearControlDiv.index = 3;
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(customControlDiv);
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(fenceControlDiv);
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(clearControlDiv);
    };

    var updateFence = function (fenceLength, corners, gates) {
        $('.js-fence-design-length').val(Math.round(fenceLength));
        document.getElementsByClassName('js-fence-design-length')[0].dispatchEvent(new Event('input'));
        document.getElementsByClassName('js-fence-design-length')[0].dispatchEvent(new Event('change'));
        $('.js-gates').val(gates);
        document.getElementsByClassName('js-gates')[0].dispatchEvent(new Event('input'));
        document.getElementsByClassName('js-gates')[0].dispatchEvent(new Event('change'));
        $('.js-corners').val(corners);
        document.getElementsByClassName('js-corners')[0].dispatchEvent(new Event('input'));
        document.getElementsByClassName('js-corners')[0].dispatchEvent(new Event('change'));

    };
    var CustomControl = function (controlDiv, map) {
        // Set CSS for the control border
        var controlUI = setupControlDiv(controlDiv, '#bdffa8', 'Gate');
        // Setup the click event listeners
        google.maps.event.addDomListener(controlUI, 'click', function () {
            drawingManager.setDrawingMode('marker');
            drawingManager.setOptions({
                markerOptions: {
                    icon: "http://www.waratahfencing.com.au/assets/img/gate-icon.png"
                },
                polylineOptions: {
                    strokeColor: '#94e2ff',
                    editable: true
                }
            });
        });
    };
    var FenceControl = function (controlDiv, map) {
        // Set CSS for the control border
        var controlUI = setupControlDiv(controlDiv, '#ffff99', 'Fence');
        // Setup the click event listeners
        google.maps.event.addDomListener(controlUI, 'click', function () {
            drawingManager.setDrawingMode('polyline');
            drawingManager.setOptions({
                markerOptions: {
                    icon: "http://www.waratahfencing.com.au/assets/img/gate-icon.png"
                },
                polylineOptions: {
                    strokeColor: '#94e2ff',
                    editable: true
                }
            });
        });
    };
    var ClearControl = function (controlDiv, map) {
        // Set CSS for the control border
        var controlUI = setupControlDiv(controlDiv, '#ffaaaa', 'Clear');
        // Setup the click event listeners
        google.maps.event.addDomListener(controlUI, 'click', function () {
            clearMap();
        });
    };
    var setupControlDiv = function (controlDiv, color, text) {
        var controlUI = document.createElement('div');
        controlUI.style.backgroundColor = color;
        controlUI.style.borderStyle = 'solid';
        controlUI.style.borderWidth = '1px';
        controlUI.style.borderColor = '#ccc';
        controlUI.style.marginTop = '4px';
        controlUI.style.marginLeft = '-6px';
        controlUI.style.cursor = 'pointer';
        controlUI.style.textAlign = 'center';
        controlDiv.style.marginLeft = '5px';
        controlDiv.appendChild(controlUI);

        // Set CSS for the control interior
        var controlText = document.createElement('div');
        controlText.style.fontFamily = 'Arial,sans-serif';
        controlText.style.fontSize = '9px';
        controlText.style.paddingLeft = '4px';
        controlText.style.paddingRight = '4px';
        controlText.style.paddingTop = '7px';
        controlText.style.paddingBottom = '7px';
        controlText.innerHTML = text;
        controlUI.appendChild(controlText);

        return controlUI;
    };
    var clearMap = function () {
        for (var i = 0; i < fences.length; i++) {
            fences[i].setMap(null);
        }
        for (var g = 0; g < gateIcons.length; g++) {
            gateIcons[g].setMap(null);
        }
        fences = [];
        gateIcons = [];
        fenceLength = 0;
        corners = 0;
        gates = 0;
        updateFence(0, 0, 0);
    };
    return {
        init: function () {
            initMap();
        }
    };
});